import { render, staticRenderFns } from "./midR.vue?vue&type=template&id=0f883d55&scoped=true"
import script from "./midR.vue?vue&type=script&lang=js"
export * from "./midR.vue?vue&type=script&lang=js"
import style0 from "./midR.vue?vue&type=style&index=0&id=0f883d55&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f883d55",
  null
  
)

export default component.exports